import Typography from '@mui/material/Typography';
import React from 'react';
import {BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList} from 'recharts';
import {UserActivityTypes} from "../../types";
import {Box} from "@mui/material";

interface Props{
    data: UserActivityTypes.ActiveUserData[]
    onRowClick : (teamName : string) => void;
}

const HorizontalBarChart : React.FC<Props> = ({data, onRowClick}) => {

    const getData = () => {
        return data.map((item) => ({
            name: item.teamName,
            value: item.activePercentage ? Math.round(Number(item.activePercentage)) : 0,
        }));
    }

    // Calculate dynamic height based on data length
    const minBarHeight = 30; // Minimum space per bar
    const chartHeight = Math.max(400, data.length * minBarHeight);

    return (
        <div style={{ width: '100%', height: 400 }}>
            {data.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', margin: 'auto' }}>
                    <Typography align={"center"} fontSize={16} fontWeight={600}>
                        No data available
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography align={"center"} fontWeight={400} fontSize={16}>Percent of Active POM Users</Typography>
                    <div style={{ height: 400, overflowY: 'auto' }}> {/* Scrollable container */}
                        <ResponsiveContainer width="100%" height={chartHeight}>
                            <BarChart
                                data={getData()}
                                layout="vertical"
                                margin={{ top: 20, bottom: 5 }}
                            >
                                <XAxis type="number" domain={[0, 100]} hide={true}/>
                                <YAxis
                                    dataKey="name"
                                    type="category"
                                    width={180}
                                    interval={0}
                                    tick={{ fontSize: 14, fontWeight : 400 }}
                                    tickFormatter={(value) => value.length > 15 ? value.substring(0, 15) + '...' : value}

                                />
                                <Tooltip formatter={(value) => [`${Math.round(Number(value))}%`, 'Percentage']} />
                                <Bar
                                    style={{cursor : 'pointer'}}
                                    dataKey="value"
                                    fill="#11A7E2"
                                    name="Percentage"
                                    barSize={25}
                                    onClick={(chartObj) => onRowClick(data.find((item) => item.teamName === chartObj.name)?.teamId || '')}
                                >
                                    <LabelList
                                        dataKey="value"
                                        position="right"
                                        formatter={(value : any) => `${value}%`}
                                        style={{ fill: '#11A7E2', fontWeight: 500, cursor : 'pointer' }}
                                    />
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </>
            )}
        </div>
    );
};

export default HorizontalBarChart;